import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import httpService from "../services/httpService"; // your axios wrapper


import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Image from 'react-bootstrap/Image';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import { useAuthStore } from '../store/store';
import { redeemPendingInvite } from '../utils/pendingInvite';

const Auth = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const setToken = useAuthStore(state => state.setToken);
    const setUser = useAuthStore(state => state.setUser);

    useEffect(() => {
        const code = searchParams.get("code");
        if (!code) {
            setError("No code provided");
            setLoading(false);
            return;
        }

        // Exchange code for token
        httpService
            .post("/authorization", { code })
            .then(async res => {
                setToken(res.data.token);
                setUser(res.data.user);
                const role = res.data.role;
                const flow = res.data.flow;
                let route = '/register';
                if (role === 'podcaster') {
                    route = flow === 'dashboard' ? '/podcaster-dashboard' : '/wizard/start';
                } else if (role === 'listener') {
                    route = flow === 'dashboard' ? '/listener-dashboard' : '/listener/start';
                }

                // If user arrived via invite flow (e.g. /join?code=...), redeem the
                // stored token now that they're authenticated instead of dumping them
                // on the generic dashboard/onboarding route.
                if (await redeemPendingInvite(navigate)) return;

                navigate(route);
            })
            .catch(err => {
                setError("Authentication failed.");
            })
            .finally(() => setLoading(false));
    }, [searchParams, navigate]);

    return (
        <Container className="d-flex justify-content-center align-items-center min-vh-100">
            <Card style={{
                width: '50%',
                overflow: 'hidden',
                margin: 0
            }}>
                <Row className="g-0">
                    <Col sm={12}>
                        <div className='p-5 text-center'>
                            <h3>Authenticating...</h3>
                            {loading && <p>This should be quick!</p>}
                            {error && <p style={{color:'red'}}>{error}</p>}
                            {!loading && !error && <p>Redirecting...</p>}
                            <Link to="/signup">Go to Sign Up</Link> <br/>
                            <Link to="/login">Go to Login</Link>
                        </div>
                    </Col>
                </Row>
            </Card>
        </Container>
    );
};

export default Auth;
